<div class="dashboard-head">
  <div>
    <h1 class="ecb-section-title">Student Dashboard</h1>
    <p class="ecb-muted">View your training enrolments and payment status.</p>
  </div>
  <a routerLink="/course-qualifications" class="ecb-btn-primary"><i class="fa fa-plus"></i> Book Course</a>
</div>
<div class="row g-4">
  <div class="col-md-4">
    <div class="ecb-admin-card stat-card p-4"><i class="fa fa-shopping-bag fa-2x mb-3"></i>
      <h3>{{ orders.length }}</h3><span>Purchases</span>
    </div>
  </div>
  <div class="col-md-4">
    <div class="ecb-admin-card stat-card p-4"><i class="fa fa-check-circle fa-2x mb-3"></i>
      <h3>{{ paidCount }}</h3><span>Paid</span>
    </div>
  </div>
  <div class="col-md-4">
    <div class="ecb-admin-card stat-card p-4"><i class="fa fa-clock-o fa-2x mb-3"></i>
      <h3>{{ pendingCount }}</h3><span>Pending</span>
    </div>
  </div>
</div>
<div class="ecb-card p-4 mt-4">
  <h3 class="ecb-card-title">Next Steps</h3>
  <div class="next-training"><i class="fa fa-calendar-check-o"></i>
    <div><strong>Choose your next training course</strong><span>Browse available courses, add to cart and pay
        securely.</span></div><a routerLink="/course-qualifications" class="ecb-btn-outline">Browse</a>
  </div>
</div>